import { Behavior, StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import {
  GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID,
  GLOBAL_KEY_APPROVE_ME_FUNDING_APP,
} from './constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  getFormattedContactInfo,
  OTP_CONTACT_ID,
  OTP_CONTACT_METHOD,
} from '../otp/otp-util';
import {
  pushErrorToDataLayer,
  ANALYTICS_KEYS,
  pushToDataLayer,
} from '../analytics/util';
import { PgInputFactoryComponent } from 'projects/grit-core/src/lib/pg-field/pg-input-factory/pg-input-factory.component';

@Injectable()
export class SendOTPCodeBehavior extends StrictBehavior {
  static readonly DESCRIPTION = 'The behavior to save the application';

  static readonly GLOBAL_OUTPUT_PROPS = {
    error: {
      required: false,
      type: 'Error',
      name: 'error',
      friendlyName: 'Error',
      description: 'An object containing an error',
    },
    otpContactInfo: {
      required: false,
      name: 'otpContactInfo',
      type: 'object',
      description: 'The formatted and saved contact info for OTP',
    },
  };

  static readonly GLOBAL_INPUT_PROPS = {};

  static readonly VERSION = '1.0.0';

  static readonly ARGS = {
    url: {
      required: false,
      name: 'url',
      type: 'string',
      description: 'The base URL for OTP',
      default: 'https://vdc-qaswebapp08.stormwind.local/AppMeOrchestrator',
    },
    contactInfoId: {
      required: true,
      name: 'contactInfoId',
      type: 'string',
      description:
        'The id of the input field with the contact information the user inputs',
    },
    isResend: {
      required: false,
      name: 'isResent',
      type: 'boolean',
      description: 'Is this call made to resend a code?',
    },
  };

  constructor(public http: HttpClient) {
    super();
  }

  async executeBehavior(
    args: { url: string; contactInfoId: string; isResend: boolean },
    ctx: BehaviorContext
  ): Promise<any> {
    if (!args.url) {
      args.url = SendOTPCodeBehavior.ARGS.url.default;
    }
    const inputFact: PgInputFactoryComponent = ctx.getFactoryById(
      args.contactInfoId
    );

    const contactData = getFormattedContactInfo(inputFact.input.value);
    const contactId = contactData.contactId;
    const contactMethod = contactData.contactMethod;
    ctx.set('otpPristine', true);

    ctx.set(OTP_CONTACT_ID, contactId);
    ctx.set(OTP_CONTACT_METHOD, contactMethod);

    const payload = {
      AuthorizationId: contactId,
    };

    try {
      // TODO: CORS is currently turned off... need the Approve.Me Presentation layer.
      // const result = await this.http.post<any>(args.url, payload).toPromise();

      this.pushToAnalytics(args.isResend);
    } catch (err) {
      ctx.set('error', err);
      pushErrorToDataLayer('otp-send-code', err.message);
    }
  }

  pushToAnalytics(isResend = false) {
    pushToDataLayer({
      event: ANALYTICS_KEYS.EVENT_TRACKER,
      eventCategory: ANALYTICS_KEYS.OTP,
      eventAction: isResend ? 'Resend Code Click' : 'Send Code Click',
      eventLabel: '',
      eventValue: 0,
      eventNonInteraction: 0,
    });
  }
}
